module.exports = __webpack_public_path__ + "media/images/photos/26-bcdc41f057b074a8433bd45ef297c720.jpg";